import { render, staticRenderFns } from "./templateAction.vue?vue&type=template&id=a50cd436&"
import script from "./templateAction.vue?vue&type=script&lang=js&"
export * from "./templateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports